import { CONSUMER_SESSION_AUTH } from "../constants";

const useConsumerAuth = () => {
  const getSession = () =>
    JSON.parse(sessionStorage.getItem(CONSUMER_SESSION_AUTH));

  const updateSession = newSessionData => {
    const currentSession = getSession();

    sessionStorage.setItem(
      CONSUMER_SESSION_AUTH,
      JSON.stringify({
        ...currentSession,
        ...newSessionData
      })
    );
  };

  const {
    phone_number = "",
    dob = "",
    token = "",
    session_token = "",
    first_name = "",
    last_name = ""
  } = getSession();

  return {
    phone_number,
    dob,
    token,
    session_token,
    first_name,
    last_name,
    updateSession
  };
};

export { useConsumerAuth };
